
export class AuthDataModel {
    constructor (access_token, userName, type, userPermissions, fullName, resetPassword, userId) {
        this.access_token = access_token;
        this.userName = userName;
        this.type = type;
        this.userPermissions = userPermissions;
        this.fullName = fullName;
        this.resetPassword = resetPassword;
        this.userId = userId;
    }

    access_token: string;
    userName: string;
    type: string[];
    userPermissions: string[];
    fullName: string;
    resetPassword: string;
    userId: number;
}


// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/app/models/auth.data.model.ts